export default "__VITE_ASSET__7ce235da__"